import { render, staticRenderFns } from "./LicenseeForm.vue?vue&type=template&id=cddd8c92&scoped=true"
import script from "./LicenseeForm.vue?vue&type=script&lang=js"
export * from "./LicenseeForm.vue?vue&type=script&lang=js"
import style0 from "./LicenseeForm.vue?vue&type=style&index=0&id=cddd8c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddd8c92",
  null
  
)

export default component.exports